import axios from "../http";

class ExpressIncome {
  getExpressIncomePice(dateTime) {
    const url = `/zwy/api/order/count/express/date?dateTime=${dateTime}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ExpressIncome;
